export default __webpack_public_path__ + "static/media/home.b20a156b.png";